
<ul>
    <li *ngFor="let post of posts">
        <a href="/landings/{{post.slug}}">{{post.title.rendered}}</a>
    </li>
</ul>
